import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";

async function create(data) {
  const response = await http.postData("/checklist-ok", data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function getByRegister(register_id: string | number) {
  const response = await http.getData(`/register/${register_id}/checklist-ok`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function updateSignIn(id: number, data) {
  const response = await http.putData(`/checklist-ok/${id}/sign-in`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function updateTimeOut(id: number, data) {
  const response = await http.putData(`/checklist-ok/${id}/time-out`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function updateSignOut(id: number, data) {
  const response = await http.putData(`/checklist-ok/${id}/sign-out`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function sign(id: number, role: string, data) {
  const response = await http.putData(`/checklist-ok/${id}/${role}`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function signAnestesiIn(id: number, data) {
  return sign(id, "sign-anestesi-in", data);
}

async function signNurseIn(id: number, data) {
  return sign(id, "sign-nurse-in", data);
}

async function signTimeOutOperator(id: number, data) {
  return sign(id, "sign-time-out-operator", data);
}

async function signTimeOutAnestesi(id: number, data) {
  return sign(id, "sign-time-out-anestesi", data);
}

async function signTimeOutSirkuler(id: number, data) {
  return sign(id, "sign-time-out-sirkuler", data);
}

async function signTimeOutSirkuler2(id: number, data) {
  return sign(id, "sign-time-out-sirkuler-2", data);
}

async function signTimeOutScrub(id: number, data) {
  return sign(id, "sign-time-out-scrub", data);
}

async function signOperatorOut(id: number, data) {
  return sign(id, "sign-operator-out", data);
}

async function signAnestesiOut(id: number, data) {
  return sign(id, "sign-anestesi-out", data);
}

async function signNurseOut(id: number, data) {
  return sign(id, "sign-nurse-out", data);
}

async function destroy(id: number) {
  const response = await http.deleteData(`/checklist-ok/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

function print(id) {
  window.open(`${http.getAPI()}/checklist-ok/${id}/pdf`, "_blank");
}

export default {
  create,
  getByRegister,
  updateSignIn,
  updateTimeOut,
  updateSignOut,
  signAnestesiIn,
  signNurseIn,
  signTimeOutOperator,
  signTimeOutAnestesi,
  signTimeOutSirkuler,
  signTimeOutSirkuler2,
  signTimeOutScrub,
  signOperatorOut,
  signAnestesiOut,
  signNurseOut,
  destroy,
  print
};
